import React from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Button } from 'reactstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const AddMessageToDialogButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> </span>
      Add Message to Dialog
    </Button>
  );
};
export const AddTagsToDialogButton = () => {
  return (
    <Button
      color="secondary"
      className="add-button"
      size="xs"
      style={{ width: '100%' }}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span> </span>
      Add Tags to Dialog
    </Button>
  );
};
export const DeleteButton = () => {
  return (
    <Button color="danger" size="xs" className="add-button">
      <IntlMessages id="property.delete" />
    </Button>
  );
};
